import { ReactElement, useEffect, useState } from 'react'
import { useMatchMedia } from '../../../hooks/useMatchMedia'
import { pageBreakpoints } from '../../../config/pageBreakpoints'
import { useNavigate, useParams } from 'react-router-dom'
import { useRosterStore, WrestlerData } from '../../../stores/RosterStore'
import { MobileWrestlerDetailView } from '../../../components/wrestler/MobileWrestlerDetailView'
import { WebWrestlerDetailView } from '../../../components/wrestler/WebWrestlerDetailView'
import { SpinnerWrapper } from '../../../components/spinner/SpinnerWrapper'

export const WrestlerDetailScreen = (): ReactElement => {
  const isMobile = useMatchMedia(`(max-width:${pageBreakpoints.md})`)
  const navigate = useNavigate()
  const { wrestlerSlug } = useParams<{ wrestlerSlug: string }>()
  const { loaded, getWrestler } = useRosterStore()
  const [wrestlerDetail, setWrestlerDetail] = useState<WrestlerData>()

  useEffect(() => {
    if (loaded) {
      if (wrestlerSlug) {
        const wrestler = getWrestler(wrestlerSlug)
        if (!wrestler) {
          console.error('Wrestler not found:', wrestlerSlug)
          navigate('/roster')
        }
        setWrestlerDetail(wrestler)
      }
    }
  }, [loaded, wrestlerSlug])

  const navigateBack = (): void => {
    navigate('/roster')
  }

  return (
    <SpinnerWrapper loaded={loaded} isMobile={isMobile}>
      {wrestlerDetail === undefined ? (
        <></>
      ) : isMobile ? (
        <MobileWrestlerDetailView
          data={{
            wrestler: wrestlerDetail,
            onBackClick: navigateBack,
          }}
        />
      ) : (
        <WebWrestlerDetailView
          data={{
            wrestler: wrestlerDetail,
            onBackClick: navigateBack,
          }}
        />
      )}
    </SpinnerWrapper>
  )
}
